var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIngresosMensuales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5776 7.36279H17.8745C18.9765 7.36279 19.8699 8.20913 19.8699 9.25313V16.8145C19.8699 17.8585 18.9765 18.7048 17.8745 18.7048H3.90701C2.805 18.7048 1.91165 17.8585 1.91165 16.8145V9.25313C1.91165 8.20913 2.805 7.36279 3.90701 7.36279H8.54692",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.093 16.1931C21.195 16.1931 22.0884 15.3468 22.0884 14.3028V6.74142C22.0884 5.69741 21.195 4.85107 20.093 4.85107H6.12549C5.02349 4.85107 4.13013 5.69741 4.13013 6.74142",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1093 9.831C12.6847 9.40647 11.9373 9.11147 11.25 9.09288M11.25 9.09288C10.432 9.07057 9.70065 9.44056 9.70065 10.4507C9.70065 12.31 13.1093 11.3804 13.1093 13.2396C13.1093 14.3 12.2019 14.7555 11.25 14.7214M11.25 9.09288V6.84814M9.39078 13.8593C9.78989 14.3923 10.533 14.696 11.25 14.7214M11.25 14.7214V16.881",
    stroke: "#01295F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIngresosMensuales);
export default __webpack_public_path__ + "static/media/ic_ingresos_mensuales.adc7f02ec2aa75fafb871fbd8db31888.svg";
export { ForwardRef as ReactComponent };